(function () {
  if (window.AstrumHeaderInvert) {
    return;
  }

  const thresholds = [];
  for (let i = 0; i <= 100; i += 1) {
    thresholds.push(i / 100);
  }

  function updateState(rect, className) {
    const isActive = rect.top <= 0 && rect.bottom > 0;
    document.body.classList.toggle(className, isActive);
  }

  function createObserver(target, className) {
    updateState(target.getBoundingClientRect(), className);

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(function (entries) {
        for (let i = 0; i < entries.length; i += 1) {
          updateState(entries[i].boundingClientRect, className);
        }
      }, {
        threshold: thresholds
      });

      observer.observe(target);
      return function () {
        observer.disconnect();
      };
    }

    const handler = function () {
      updateState(target.getBoundingClientRect(), className);
    };

    handler();
    window.addEventListener("scroll", handler, { passive: true });
    window.addEventListener("resize", handler);

    return function () {
      window.removeEventListener("scroll", handler);
      window.removeEventListener("resize", handler);
    };
  }

  function resolveTarget(wrapper) {
    if (!wrapper) {
      return null;
    }
    if (wrapper instanceof Element) {
      return wrapper;
    }
    if (typeof wrapper === "string") {
      return document.getElementById(wrapper);
    }
    return null;
  }

  const registry = new Map();

  function register(options) {
    if (!options || !options.className) {
      return;
    }
    const target = resolveTarget(options.wrapper);
    if (!target) {
      return;
    }
    const key = options.className;
    if (registry.has(key)) {
      const teardown = registry.get(key);
      if (typeof teardown === "function") {
        teardown();
      }
    }
    const teardown = createObserver(target, key);
    registry.set(key, teardown);
  }

  window.AstrumHeaderInvert = { register: register };
})();


